import React, { useCallback, useState, } from "react";
import { Input as ChakraInput } from "@chakra-ui/react";
import { useFocusRing } from "react-aria";
export function TextInput({ isDisabled, isReadOnly, width = "xs", onFocus, onBlur, ...props }) {
    const [isFocused, setIsFocused] = useState(false);
    const { isFocusVisible, focusProps } = useFocusRing({
        isTextInput: true,
    });
    const inputFocused = useCallback((event) => {
        setIsFocused(true);
        focusProps.onFocus?.(event);
        onFocus?.(event);
    }, [focusProps, onFocus]);
    const inputBlurred = useCallback((event) => {
        setIsFocused(false);
        focusProps.onBlur?.(event);
        onBlur?.(event);
    }, [focusProps, onBlur]);
    return (React.createElement(ChakraInput, { isReadOnly: isReadOnly ?? isDisabled, isDisabled: isDisabled, boxShadow: isFocused && isFocusVisible ? "outlineGreen" : undefined, width: width, maxWidth: "100%", onFocus: inputFocused, onBlur: inputBlurred, ...props }));
}
